export default __webpack_public_path__ + "static/media/diamond-color-table_over-md@3x.8c2b8de5.png";